module.exports = __webpack_public_path__ + "img/kr-product-content3-img-3.aa7d1e7.png";